// test2610
(2610 && 0);
